<template>
  <svg
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="10"
    viewBox="0 0 16 10"
  >
    <path
      d="M9,4.5a8.62,8.62,0,0,0-8,5,8.62,8.62,0,0,0,8,5,8.62,8.62,0,0,0,8-5A8.62,8.62,0,0,0,9,4.5Zm0,8.333A3.5,3.5,0,0,1,5.364,9.5,3.5,3.5,0,0,1,9,6.167,3.5,3.5,0,0,1,12.636,9.5,3.5,3.5,0,0,1,9,12.833ZM9,7.5a2.094,2.094,0,0,0-2.182,2A2.094,2.094,0,0,0,9,11.5a2.094,2.094,0,0,0,2.182-2A2.094,2.094,0,0,0,9,7.5Z"
      transform="translate(-1 -4.5)"
    />
  </svg>
</template>

<script>
export default {
  name: "eyeIcon",
};
</script>
